import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentBankItem from "../ContentBankItem/ContentBankItem";
import AddFromOldSystemBtn from "../ContentBankItemList/AddFromOldSystemBtn";
import * as PathRouter from '../../../../models/PathRoute';
import AddNewItemBtn from "../ContentBankItemList/AddNewItemBtn";
import NewProject from "../../MaterialLibrary/NewProject";
import { projectsApi } from "../../../../utils";
import { ObjectTypeEnum, ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import classes from './MyMaterials.module.css';
import { useNavigate } from "react-router-dom";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import ToastMessage from "../../../UI/ToastMessage";
import ForwardLessonBtn from "../../MaterialLibrary/ForwardLessonBtn";
import Moment from 'moment';
import Loader from "../../../lms-shared/UI/Loader/Loader";

const ProjectTypeData = ({ myMaterialList, setMessage, changeLibraryData, fromPopup, selectedMaterial, setSelectedMaterial }) => {

    const { homeUrl, applicationId } = useSelector(state => state.application);
    const texts = useSelector(state => state.translate.texts);
    const { user } = useSelector(state => state.auth);
    const importOldProjects = useSelector(state => state.application.importOldProjects);
    const [loader, setLoader] = useState(false);

    const [showAddProject, setShowAddProject] = useState();
    const navigate = useNavigate()

    const dispatch = useDispatch();

    function projectItemClick(item) {
        if (setSelectedMaterial) {
            setSelectedMaterial(item);
        }
        else {
            navigate(`${homeUrl}/${PathRouter.PROJECT}/${item.id}`, { state: { prevPath: window.location.pathname, replace: true } })
        }
    }

    const createNewProject = (newProject) => {
        if (newProject.isAllowed) {
            setLoader(true)
            const data = {
                name: newProject.name,
                description: newProject.description,
                ideId: newProject.id,
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId
            }
            projectsApi.projectsAddPost({ "projectAddInput": data }, (error, resdata, response) => {
                if (error) {
                    console.log('error in projectsAddPost', error)
                    dispatch(throwApiError({ userMessage: 'error in projectsAddPost', error: error, statusCode: response?.statusCode, message: "projectsAddPost " + error.message, level: 1, component: "ProjectTypeData", line: 52 }))
                } else {
                    changeLibraryData('CREATE', [{ ...data, ...resdata }])
                }
                setLoader(false)
            })
        }
    }

    function handleCopy(e, id, showPopup, close) {
        e.stopPropagation()
        const opts = {
            id: id,
            file: null,
            refObjectType: ObjectTypeNamesEnum.Application,
            refObjectId: applicationId
        }

        projectsApi.projectsDuplicatePost(opts, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentProjectsDuplicate, error: error, statusCode: response?.statusCode, message: "projectsDuplicatePost " + error.message, level: 2, component: "ProjectTypeData", line: 72 }))
            }
            else {
                showPopup(<ToastMessage text={texts.MessageContentSuccessCopyProjectStatus} color="green" close={close} />)
                const newObj = myMaterialList.filteredData.find(p => p.id == id)
                changeLibraryData('CREATE', [{ ...newObj, createdDate: opts.createdDate, id: resdata }])
            }
        })
    }

    function handleRestore(e, id, showPopup, close, setMessagePopup) {
        e.stopPropagation()
        projectsApi.projectsRestoreIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentRestoreProjectStatus, error: error, statusCode: response?.statusCode, message: "projectsDeleteIdPost " + error.message, level: 2, component: "Project", line: 60 }))
            }
            else {
                // showPopup(<ToastMessage text={texts.MessageContentSuccessCopyProjectStatus} color="green" close={close} />)
            }
        })
        setMessagePopup(false)
    }

    function handleEditName(e, projectId, newName, setIsEditName) {
        e.stopPropagation()
        if (newName && newName !== '') {
            const data = {
                id: projectId,
                name: newName
            }
            projectsApi.projectsUpdatePost({ "projectUpdateInput": data }, (error, resdata, response) => {
                if (error) {
                    let userMessage = texts.projectsUpdateError;
                    if (response.text == "Too long name") {
                        userMessage = texts.projectNameUpdateError;
                    }
                    dispatch(throwApiError({ userMessage, error: error, statusCode: response?.statusCode, message: "projectsUpdatePost " + error.message, level: 2, component: "Projects", line: 74 }))
                } else {
                    const newObj = myMaterialList.filteredData.find(m => m.id == projectId);
                    changeLibraryData('UPDATE', { ...newObj, name: newName });
                    setIsEditName(false)
                }
            })
        }
    }

    function handleDelete(e, id, showPopup, close, setMessagePopup) {
        e.stopPropagation();
        projectsApi.projectsDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "projectsDeleteIdPost " + error.message, level: 2, component: "ProjectTypeData", line: 103 }))
            }
            else {
                showPopup(<ToastMessage text={texts.MessageContentSuccessDeleteProjectStatus} color="green" close={close} />)
                changeLibraryData('DELETE', id);
            }
        })
        setMessagePopup(false)
    }

    const handleForward = m => <ForwardLessonBtn ViewAnimate={true} ViewText={texts.copyLinkToCode} setMessage={setMessage} data={m} type={ObjectTypeEnum.Project} />

    return (
        myMaterialList && <>
            {loader ? <Loader /> :
                <>
                    {!fromPopup && myMaterialList.filter?.refObjectType == ObjectTypeEnum.Application && <AddNewItemBtn upload={() => setShowAddProject(true)} text={texts.createNewProjectBtn}></AddNewItemBtn>}
                    {!fromPopup && importOldProjects && <AddFromOldSystemBtn contentBankItemList={myMaterialList?.filteredData} changeLibraryData={changeLibraryData}></AddFromOldSystemBtn>}
                    {myMaterialList?.filteredData && [].concat(myMaterialList?.filteredData).sort((a, b) => a.lastCreatedHistoryDate < b.lastCreatedHistoryDate ? 1 : -1).map((m, i) =>
                        <div key={i} className={`${classes.ContentBankItemWrapper} ${selectedMaterial && selectedMaterial === m.id ? classes.Select : ``} `}>
                            <ContentBankItem contentBankItem={m} showProjectPopup={!fromPopup} setContentBankItem={projectItemClick} handleCopy={handleCopy} handleDelete={handleDelete} handleEditName={handleEditName} handleForward={handleForward(m)} handleRestore={handleRestore} />
                        </div>
                    )}
                    {showAddProject && <NewProject createNewProject={createNewProject} closePopup={() => setShowAddProject(false)} ></NewProject>}
                </>}
        </>
    )
}
export default ProjectTypeData;